import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import { push } from 'react-router-redux';
import { doNewAuth } from '../actions/auth';
import { showSectionIncomplete, resetSectionIncomplete } from '../actions/section';
import { resetOptions } from '../actions/status';
import { contentReset } from '../actions/content';
import { logoutPrepare, logout } from '../actions/login';
import { resetAll } from '../actions/status';
import { hideNextButton } from '../actions/next';
import { resetPayever } from '../actions/payever';
import LocalStorageUtils from './LocalStorageUtils';
var AppConfig = require('../config.json');

const pathToClass = path => {
  return path.substr(1).split('/').join('-');
};


class AppController extends Component {
  constructor(props) {
    super(props);
    this.addReady = this.addReady.bind(this);
    this.addClassName = this.addClassName.bind(this);
    this.removeClassName = this.removeClassName.bind(this);
    this.addContentVisible = this.addContentVisible.bind(this);
    this.goLogout = this.goLogout.bind(this);
    this.goNext = this.goNext.bind(this);
    let urls = [];
    for (var key in AppConfig.links) {
      urls.push("/"+AppConfig.links[key].url);
    }
    this.state = {urls: urls, change: false, ready:false};
  }

  componentDidMount() {
    this.props.setTimeout(this.addReady, 200);
  }
  addReady() {
    this.setState({ready:true});
    this.addClassName('ready');
    this.props.setTimeout(this.addContentVisible, 200);
  }
  addContentVisible() {
    this.addClassName('contentvisible');
  }
  addClassName(str) {
    if(str==='') {
      return;
    }
    document.getElementById('outer-container').classList.add(str);
  }
  removeClassName(str) {
    if(str==='') {
      return;
    }
    document.getElementById("outer-container").classList.remove(str);
  }
  goLogout() {
    this.props.dispatch(logout());
  }
  goNext() {
    
    if(!LocalStorageUtils.lastActivityOk()) {
      if(!this.props.isLoggingOut) {
        this.props.dispatch(logoutPrepare());
        this.props.dispatch(push('logout'));
        
        
        return;
      }
      
    }
    if(!this.props.isLoggingOut) {
      LocalStorageUtils.setActivity();
    }

    this.props.dispatch(push(this.props.linkTo));
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.props.linkTo!==nextProps.linkTo && nextProps.linkTo!=='' && !this.state.change) {
      this.props.dispatch(hideNextButton());
      this.setState({change:true});
      this.addClassName('change');
      this.removeClassName('contentvisible');
      this.props.setTimeout(this.goNext, 300);
    }
    if(this.props.pathname !== nextProps.pathname) {
      this.checkConsistentData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
      if(this.props.pathname !== prevProps.pathname) {
        this.props.dispatch(doNewAuth());
        this.checkSectionStatus();
        this.removeClassName(pathToClass(prevProps.pathname));
        this.addClassName(pathToClass(this.props.pathname));
       } else {
          if(this.state.ready!==prevState.ready) {
            this.checkSectionStatus();
          }
       }
      if(this.props.isAuthenticated === true) {
        if(this.props.pathname !== prevProps.pathname && this.props.status.project.isset!==true) {
          LocalStorageUtils.logout();
          this.props.dispatch(push('/login'));
        }
      }
    if(this.state.change) {
      if(this.props.pathname === '/'+this.props.linkTo || prevState.isLoggingOut) {
        this.setState({change:false});
        this.removeClassName('change');
        this.props.setTimeout(this.addContentVisible, 200);
        this.props.dispatch(contentReset());
      }
    }
  }
  checkConsistentData() {
    if(this.state.urls.indexOf(this.props.pathname)===-1 || !this.props.status.bundle.isset) {
      return;
    }
    var bundleId = this.props.status.bundle.id;
    if(this.props.status.options.isset && this.props.status.options.bundleId!==bundleId) {
      this.props.dispatch(resetOptions());
    }
  }
  checkSectionStatus() {
    if(this.state.urls.indexOf(this.props.pathname)===-1) {
      return;
    }
    let checks = [], obj = {isActive: false, label: "", link: ""};
    for (var key in AppConfig.links) {
      checks.push(AppConfig.links[key]);
      if(this.props.pathname==="/"+AppConfig.links[key].url) {
        break;
      }
    }
    for (var n = 0; n < checks.length; n++) {
      if(checks[n].sectionCheck && !this.props.status[checks[n].statusBeforeRequired].isset) {
        if(n>0) {
          obj.isActive = true;
          obj.link = checks[(n-1)].url;
          obj.label = "« Zurück zu: \""+checks[(n-1)].label+"\"";
          break;
        }
      }
    }
    if(obj.isActive) {
      this.props.dispatch(showSectionIncomplete(obj));
    } else if(this.props.section.isActive) {
      this.props.dispatch(resetSectionIncomplete());
    }
  }

  render() {

    return (
        <div id="appcontroller"></div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pathname: state.routing.location.pathname,
    section: state.section,
    status: state.status,
    linkTo: state.content.link,
    isLoggingOut: state.auth.isLoggingOut,
    isAuthenticated: state.auth.isAuthenticated
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(AppController))


// WEBPACK FOOTER //
// ./src/utils/AppController.js